<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
	<div id="skill-list-content-loading" class="vs-con-loading__container">
		<vx-card
			no-shadow
			card-border
			class="custom-height"
			:title="$t('Skills.TotalSkills') + ': ' + assignedSkills.length"
		>
			<template slot="actions" v-if="customConfig.navbarOptions">
				<div class="flex flex-row justify-between">
					<vx-tooltip
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Skills.AssignSkill')"
						:text="$t('Skills.AssigneSkillTooltip')"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-plus"
							:disabled="activeAlert2"
							@click.prevent="showSkillList()"
						></vs-button>
					</vx-tooltip>

					<vx-tooltip
						v-if="assignedSkills.length > 0"
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Crud.Delete')"
						:text="null"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-trash-2"
							@click.stop="openDeleteAllConfirm"
						></vs-button>
					</vx-tooltip>

					<vs-dropdown vs-custom-content :vs-trigger-click="false" class="cursor-pointer">
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-layout"
						></vs-button>
						<vs-dropdown-menu style="width: 35%">
							<vx-card no-shadow :title="$t('AssignedTeams.Columns')">
								<p>{{ $t("AssignedTeams.ColumnsText") }}</p>
								<ul class="demo-alignment">
									<li>
										<vs-checkbox v-model="checkBoxName">{{ $t("Name") }}</vs-checkbox>
									</li>
									<li>
										<vs-checkbox v-model="checkBoxDescription">{{ $t("Description") }}</vs-checkbox>
									</li>
								</ul>
							</vx-card>
						</vs-dropdown-menu>
					</vs-dropdown>
					<vx-tooltip
						v-if="skillListIds.length > 0"
						class="cursor-pointer"
						color="primary"
						position="bottom"
						delay=".1s"
						:title="$t('Refresh')"
						:text="null"
					>
						<vs-button
							class="ml-1"
							color="primary"
							type="filled"
							icon-pack="feather"
							icon="icon-refresh-ccw"
							@click.stop="getAssignedSkillsByIds(skillListIds)"
						></vs-button>
					</vx-tooltip>
				</div>
			</template>

			<vue-perfect-scrollbar class="scroll-area" :settings="settings">
				<vs-table
					v-if="assignedSkills.length"
					ref="table"
					v-model="selected"
					search
					:max-items="itemsPerPage"
					:data="assignedSkills"
				>
					<template slot="thead">
						<vs-th sort-key="name" v-show="enableHeadTable('name') && checkBoxName">{{ $t("Name") }}</vs-th>
						<vs-th sort-key="description" v-show="enableHeadTable('description') && checkBoxDescription">{{
							$t("Description")
						}}</vs-th>
						<vs-th v-show="enableHeadTable('action')">{{ $t("Routing.Table.Actions") }}</vs-th>
					</template>

					<template slot-scope="{data}">
						<tbody>
							<vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
								<vs-td v-show="enableHeadTable('name') && checkBoxName">
									<p class="product-name font-medium truncate">{{ tr.name }}</p>
								</vs-td>

								<vs-td v-show="enableHeadTable('description') && checkBoxDescription">
									<p class="product-category">{{ tr.description | title }}</p>
								</vs-td>
								<vs-td v-show="enableHeadTable('action')" class="whitespace-no-wrap">
									<feather-icon
										icon="TrashIcon"
										svgClasses="w-5 h-5 hover:text-danger stroke-current"
										class="ml-2"
										@click.stop="removeAssignedSkill(tr.id)"
									/>
								</vs-td>
							</vs-tr>
						</tbody>
					</template>
				</vs-table>
				<p v-else-if="activeAlert2">
					<vs-alert
						class="mt-2"
						style="overflow-y: auto"
						color="warning"
						:active.sync="activeAlert2"
						:title="$t('Skills.AssignSkills')"
					>
						{{ $t("Skills.TherAreCurrentlyNoSkillsAvailable") }}
						<span
							class="text-inherit underline"
							style="cursor: pointer"
							@click.prevent="goRouter('NewSkill')"
						>
							<feather-icon class="cursor-pointer underline" icon="PlusCircleIcon" svgClasses="h-4 w-4" />
							{{ $t("Skills.AddSkill") }}
						</span>
					</vs-alert>
				</p>
				<p v-else>
					{{ $t("Skills.NoAssignedSkills") }}
				</p>
				<slot name="alert-message"> </slot>
			</vue-perfect-scrollbar>
			<vs-popup
				:fullscreen="true"
				:title="$t('Skills.ListOfSkills')"
				:active.sync="skillMounted"
				class="vs-popup--content-custom"
			>
				<skills-list
					v-if="skillMounted"
					ref="skillList"
					style="margin-top: 65px"
					:customConfig="skillListConfig"
					@showPopupEmmit="showPopup"
				>
					<div class="is-stuck" style="background: white; z-index: 55000">
						<vx-card no-shadow card-border class="mb-8">
							<div class="form-header-inner">
								<vs-button
									class="ml-2"
									id="btn-locate-visit-point"
									icon-pack="feather"
									icon="icon-check"
									:title="$t('VisitPoints.Assig') + ' ' + $t('Routing.Title.Selection')"
									:size="iconSize"
									:disabled="getCheckedSkills.length <= 0"
									@click.prevent="setAssignedSkills"
									>{{
										windowWidth > 620
											? $t("VisitPoints.Assig") + " " + $t("Routing.Title.Selection")
											: null
									}}
								</vs-button>
							</div>
						</vx-card>
					</div>
				</skills-list>
			</vs-popup>
		</vx-card>
	</div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import SkillsList from "./SkillList.vue";
import moduleSkills from "@/store/skills/moduleSkills.js";
import {generalPurposeMixin} from "@/mixins/generalPurposeMixin.js";

export default {
	mixins: [generalPurposeMixin],
	components: {
		VuePerfectScrollbar,
		SkillsList,
	},
	props: {
		customConfig: {
			rowSelection: "multiple",
			activeCheckbox: true,
			showPopup: true,
			activeHeaderCheckboxSelection: true,
			activeLink: false,
			columns: ["id", "name", "description", "action"],
			defaultColumns: ["id", "name", "description"],
			tableOptions: true,
			showItemsPerPage: true,
			showSearch: false,
			showActions: false,
			navbarOptions: true,
		},
		skillListIds: {
			type: Array,
			default: () => [],
		},
		isAssignedSkills: {
			type: Boolean,
			default: () => true,
		},
	},
	data() {
		return {
			activeItem: false,
			selected: [],
			skillMounted: false,
			itemsPerPage: 7,
			isMounted: false,
			checkBoxName: true,
			checkBoxDescription: true,
			skillListFetched: false,
			activeAlert2: false,
			settings: {
				maxScrollbarLength: 60,
				wheelSpeed: 0.6,
			},
			skillListConfig: {
				rowSelection: "multiple",
				showPopup: true,
				activeCheckbox: true,
				activeHeaderCheckboxSelection: true,
				activeLink: false,
				columns: ["id", "name", "description", "amountVehicles", "amountVisitPoints"],
				defaultColumns: ["id", "name", "description"],
				tableOptions: true,
				showItemsPerPage: true,
				showSearch: false,
				showActions: false,
				btnAssig: false,
			},
		};
	},
	created() {
		if (!moduleSkills.isRegistered) {
			this.$store.registerModule("moduleSkills", moduleSkills);
			moduleSkills.isRegistered = true;
		}
		this.checkBoxNameLocal = this.customConfig.defaultColumns.includes("name");
		this.checkBoxDescription = this.customConfig.defaultColumns.includes("description");
	},
	mounted() {
		this.isMounted = true;
		if (this.skillListIds && this.skillListIds.length > 0 && this.isAssignedSkills) {
			this.getAssignedSkillsByIds(this.skillListIds);
		}
	},
	computed: {
		enableHeadTable() {
			return (headName) => this.customConfig.columns.includes(headName);
		},
		assignedSkills() {
			return this.$store.state.moduleSkills.listSelectedSkills;
		},
		getCheckedSkills() {
			return this.$store.state.moduleSkills.checkedSkills;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		iconSize() {
			return this.$store.state.windowWidth < 620 ? "small" : "medium";
		},
	},
	methods: {
		openLoadingContent(idContent) {
			this.$vs.loading({
				container: idContent,
				scale: 0.6,
			});
		},
		closeLoadingContent(idContent) {
			this.$vs.loading.close(`${idContent} > .con-vs-loading`);
		},
		openDeleteAllConfirm() {
			this.$vs.dialog({
				type: "confirm",
				color: "danger",
				title: this.$t("Confirm"),
				text: this.$t("Skills.Messages.DeleteAll"),
				accept: this.deleteAll,
				acceptText: this.$t("Accept"),
				cancelText: this.$t("Cancel"),
			});
		},
		deleteAll() {
			this.$store.commit("moduleSkills/REMOVE_ALL_ASSIGNED_SKILL");
		},
		showPopup(val) {
			this.skillMounted = val;
		},
		removeAssignedSkill(id) {
			this.$store.commit("moduleSkills/REMOVE_ASSIGNED_SKILL", id);
		},
		async getAssignedSkillsByIds(ids) {
			this.openLoadingContent("#skill-list-content-loading");
			await this.$store.dispatch("moduleSkills/findSkillFilter", {
				id: ids,
				fields: ["id", "name", "description"],
			});
			this.closeLoadingContent("#skill-list-content-loading");
		},
		setAssignedSkills() {
			let selectedRows = [...this.getCheckedSkills];
			this.$store.commit("moduleSkills/SET_ASSIGNED_SKILL", selectedRows);
			this.skillMounted = false;
		},
		async showSkillList() {
			if (this.skillListFetched) {
				this.skillMounted = true;
				return;
			}
			this.skillListFetched = true;
			try {
				const res = await this.$store.dispatch("moduleSkills/fetchDataListItems");
				if (res.data.length > 0) {
					this.activeAlert2 = false;
					this.skillMounted = true;
				} else {
					this.activeAlert2 = true;
				}
			} catch (err) {
				console.error(err);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.scroll-area {
	margin: auto;
	width: 100%;
	min-height: 450px;
	max-height: 450px;
}
.is-stuck {
	position: fixed;
	top: 52px;
	inset-inline-start: 0;
	margin-inline-start: 30px;
	width: calc(100% - 80px);
	z-index: 14;
}
.form-header-inner {
	display: flex;
	align-items: center;
	justify-content: flex-end;
}
</style>
